const isIOS = /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)

const isAndroid = /(Android)/i.test(navigator.userAgent)

const isWechat = /micromessenger/i.test(navigator.userAgent)

const isInsideAPP = /CustomUserAgent_C_/i.test(navigator.userAgent)

export { isIOS, isAndroid, isWechat, isInsideAPP }
